<ng-container *ngIf="!(telephonyStateService.isCallEnded && !telephonyStateService.isCallDisposed)">
    <ng-container *ngIf="dialpadService.keypadOpen">
        <app-dial-screen [number]="dialpadService.number" (numberChange)="dialpadService.setNumber($event)"
            (onRemove)="dialpadService.removeDialScreenText()"></app-dial-screen>
        <div class="dial-keypad-wrapper">
            <div class="dial-keypad" [ngClass]="{
            'dial-keypad--revised': themeService.selectedDialpadTheme.tab === themeService.DialpadTheme.NEUMORPHIC}">
                <div class="dial-keypad__btn">
                    <ng-container *ngFor="let keypad of KEYPADS">
                        <div>
                            <span (click)="dialpadService.setDialScreenText(keypad)">{{ keypad }}</span>
                        </div>
                    </ng-container>
                </div>
                <div class="dial-keypad__actions-btn" *ngIf="!telephonyStateService.onCall"
                    [ngClass]="{'disabled' : !dialpadService.callEnabled }">
                    <span (click)="dialCall()">
                        <i class="fa-solid fa-phone"></i>
                    </span>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>

<div class="caller-info" style="margin-top: 20px" *ngIf="telephonyStateService.onCall && !dialpadService.keypadOpen">
    <div class="caller-info__name">
        <h2>{{campaignService.lead?.CustomerInfo?.FirstName}} {{campaignService.lead?.CustomerInfo?.LastName}}</h2>
    </div>
    <div class="caller-info__number">
        <span>{{telephonyStateService.btn}}</span>
    </div>
    <div class="caller-info__duration">
        <p>{{ callService.stringTimer }}</p>
    </div>
    <div class="caller-info__avatar" *ngIf="!telephonyStateService.isCallEnded">
        <span class="avatar-img"><i class="fa-solid fa-user"></i></span>
    </div>
    <!-- <div class="caller-info__action-btns" *ngIf="!telephonyStateService.isCallEnded">
        <i class="fa-solid fa-phone-hangup" (click)="endCall()"></i>
    </div> -->
</div>
<ng-container *ngIf="telephonyStateService.onCall && !telephonyStateService.isCallEnded">
    <div class="call-actions call-actions--tertiary"
        [ngClass]="themeService.selectedDialpadTheme.tab === themeService.DialpadTheme.NEUMORPHIC ? ' call-actions--md-width call-actions--neumorphic' : ''">
        <div class="call-actions__btn">
            <div [ngClass]="{'disabled' : !dialpadService.muteUnmuteEnabled }" (click)="muteCall()">
                <ng-container *ngIf="!telephonyStateService.isMuted"><i class="fa-light fa-microphone-lines"></i>
                    <span
                        [attr.data-interaction]="campaignService.customerCallSid + ' - mute call'">Mute</span></ng-container>
                <ng-container *ngIf="telephonyStateService.isMuted"><i class="fa-light fa-microphone-lines-slash"></i>
                    <span [attr.data-interaction]="campaignService.customerCallSid + ' - un-mute call'">Un
                        Mute</span></ng-container>
            </div>
            <div [ngClass]="{'disabled' : !dialpadService.holdResumeEnabled }" (click)="holdCall()">
                <ng-container *ngIf="!telephonyStateService.onHold">
                    <i class="fa-light fa-pause"
                        [attr.data-interaction]="campaignService.customerCallSid + ' - hold call'"></i> <span
                        [attr.data-interaction]="campaignService.customerCallSid + ' - hold call'">Hold</span>
                </ng-container>
                <ng-container *ngIf="telephonyStateService.onHold">
                    <i class="fa-light fa-play"
                        [attr.data-interaction]="campaignService.customerCallSid + ' - resume call'"></i> <span
                        [attr.data-interaction]="campaignService.customerCallSid + ' - resume call'">Resume</span>
                </ng-container>
            </div>
            <div (click)="dialpadService.toggleKeyPad()">
                <i> <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="svg-icon svg-icon--fill">
                        <rect x="0.420898" y="0.84375" width="4" height="4" rx="2"></rect>
                        <rect x="0.420898" y="6.65625" width="4" height="4" rx="2"></rect>
                        <rect x="6.0791" y="0.84375" width="4" height="4" rx="2"></rect>
                        <rect x="6.0791" y="6.65625" width="4" height="4" rx="2"></rect>
                        <rect x="6.0791" y="12.1562" width="4" height="4" rx="2"></rect>
                        <rect x="11.5791" y="0.84375" width="4" height="4" rx="2"></rect>
                        <rect x="11.5791" y="6.65625" width="4" height="4" rx="2"></rect>
                    </svg></i>
                <span>Dialpad</span>
            </div>

            <!-- <div class="call-actions__btn--hangup" *ngIf="!telephonyStateService.isCallEnded" (click)="endCall()">
                <i class="fa-solid fa-phone-hangup"></i>
            </div> -->

            <!-- [ngClass]="{'disabled' : !dialpadService.transferEnabled }"  -->
            <div [attr.data-interaction]="campaignService.customerCallSid + ' - transfer call'"
                *ngIf="dialpadService.transferEnabled" (click)="transferCall()">
                <i [attr.data-interaction]="campaignService.customerCallSid + ' - transfer call'"
                    class="fa-light fa-arrow-right-from-bracket"></i>
                <span [attr.data-interaction]="campaignService.customerCallSid + ' - transfer call'">Transfer</span>
            </div>
            <!-- [ngClass]="{'disabled' : !dialpadService.consultEnabled }"  -->
            <div *ngIf="dialpadService.consultEnabled" (click)="consultCall()">
                <i class="fa-light fa-chalkboard-user"></i>
                <span>Consult</span>
            </div>
            <!-- [ngClass]="{'disabled' : !dialpadService.conferenceEnabled }" -->
            <div [attr.data-interaction]="campaignService.customerCallSid + ' - conference call'"
                *ngIf="dialpadService.conferenceEnabled" (click)="conferenceCall()">
                <i [attr.data-interaction]="campaignService.customerCallSid + ' - conference call'"
                    class="fa-light fa-users"></i>
                <span [attr.data-interaction]="campaignService.customerCallSid + ' - conference call'">Conference</span>
            </div>
            <!-- [ngClass]="{'disabled' : !dialpadService.toggleEnabled }" -->
            <div [attr.data-interaction]="campaignService.customerCallSid + ' - toggle call'"
                *ngIf="dialpadService.toggleEnabled" (click)="toggleCall()">
                <i [attr.data-interaction]="campaignService.customerCallSid + ' - toggle call'"
                    class="fa-light fa-toggle-on"></i>
                <span [attr.data-interaction]="campaignService.customerCallSid + ' - toggle call'">Toggle</span>
            </div>
            <!-- [ngClass]="{'disabled' : !dialpadService.cancelEnabled }" -->
            <div [attr.data-interaction]="campaignService.customerCallSid + ' - cancel third party call'"
                *ngIf="dialpadService.cancelEnabled" (click)="canceThirdPartyCall()">
                <i [attr.data-interaction]="campaignService.customerCallSid + ' - cancel third party call'"
                    class="fa-light fa-user-minus"></i>
                <span
                    [attr.data-interaction]="campaignService.customerCallSid + ' - cancel third party call'">Cancel</span>
            </div>

            <!-- add class "hide" to hide more actions -->
            <!-- <div class="call-actions__more hide"> -->
            <!-- <div class="call-actions__more" [ngClass]="{ hide: !viewMore }">

            </div> -->
        </div>
    </div>
    <div [attr.data-interaction]="campaignService.customerCallSid + ' - end call'"
        class="call-actions call-actions--tertiary" *ngIf="!telephonyStateService.isCallEnded">
        <div [attr.data-interaction]="campaignService.customerCallSid + ' - end call'" class="call-actions__btn">
            <div [attr.data-interaction]="campaignService.customerCallSid + ' - end call'"
                class="call-actions__btn--hangup" (click)="endCall()">
                <i [attr.data-interaction]="campaignService.customerCallSid + ' - end call'"
                    class="fa-solid fa-phone-hangup"></i>
            </div>
        </div>
    </div>
</ng-container>
<ng-container
    *ngIf="telephonyStateService.onCall && telephonyStateService.isCallEnded && !telephonyStateService.isCallDisposed">
    <div class="call-dropdown-wrapper">
        <form [formGroup]="campaignService.dispositionForm" action="">
            <div *ngIf="!providerService.isZIPLY_Call && !providerService.isSTAR_LINK_Call" class="single-input-field-wrapper">
                <div class="call-dropdown call-dropdown--addons">
                    <label for="addons-grp" class="call-dropdown__label">
                        Addons
                    </label>
                    <span class="call-dropdown__opt-select">
                        <f-multiSelect [style]="{ width: '100%' }" styleClass='reorder-input' placeholder="Select Addons"
                            display="chip" optionLabel="Name" name="addons" optionValue="Name" [options]="addons"
                            [(ngModel)]="campaignService.addons" [ngModelOptions]="{ standalone: true }"></f-multiSelect>
                    </span>
                </div>
            </div>
            <!-- Call Dropdown -->
            <div class="single-input-field-wrapper">
                <div class="call-dropdown">
                    <label for="disposition-grp" class="call-dropdown__label">
                        Disposition group
                    </label>
                    <span class="call-dropdown__opt-select">
                        <f-dropdown [filter]="true" placeholder="Select Disposition Group"
                            [options]="campaignService.dispositionGroups" formControlName="dispositionGroup" optionLabel="Group"
                            optionValue="Group" [ngStyle]="{ width: '100%' }" [style]="{ width: '100%' }">
                        </f-dropdown>
                    </span>
                    <div class="validation validation--error bottom-n15"
                        *ngIf="this.campaignService.checkFieldValidation('dispositionGroup', campaignService.dispositionForm)">
                        Please provide disposition group.
                    </div>
                </div>
            </div>
            <div class="single-input-field-wrapper">
                <div class="call-dropdown ">
                    <label for="disposition" class="call-dropdown__label">
                        Disposition
                    </label>
                    <span class="call-dropdown__opt-select">
                        <f-dropdown [filter]="true" placeholder="Select Disposition" [options]="campaignService.dispositions"
                            formControlName="disposition" optionLabel="Name" optionValue="Id" [ngStyle]="{ width: '100%' }"
                            [style]="{ width: '100%' }">
                        </f-dropdown>
                    </span>
                    <div class="validation validation--error bottom-n15"
                        *ngIf="this.campaignService.checkFieldValidation('disposition', campaignService.dispositionForm)">
                        Please provide disposition.
                    </div>
                </div>
            </div>
            @if(campaignService.dispositionCallbackSelection === 'Callback Scheduled') {
            <div class="single-input-field-wrapper">
                <div class="call-dropdown ">
                    <label for="callbackTimezone" class="call-dropdown__label">
                        Time Zone
                    </label>
                    <span class="call-dropdown__opt-select">
                        <f-dropdown [filter]="true" placeholder="Select Timezone" [options]="callbackConfig.timeZones"
                            formControlName="callbackTimezone" optionLabel="name" optionValue="value" [ngStyle]="{ width: '100%' }"
                            [style]="{ width: '100%' }" (onChange)="updateMinDate($event.value)">
                        </f-dropdown>
                    </span>
                    <div class="validation validation--error bottom-n15"
                        *ngIf="this.campaignService.checkFieldValidation('callbackTimezone', campaignService.dispositionForm)">
                        Please provide timezone.
                    </div>
                </div>
            </div>
            
            <div class="single-input-field-wrapper">
                <div class="call-dropdown">
                    <div>
                        <label for="callbackDate" class="call-dropdown__label">
                            Date
                        </label>
                        <div class="custom-calendar">
                            <i class="calendar-icon fa-light fa-calendar"></i>
                            <p-calendar width="100%" placeholder="Callback Date" formControlName="callbackDate"
                                [minDate]="callbackConfig.minDate">
            
                            </p-calendar>
                        </div>
                        <div class="validation validation--error bottom-n15"
                            *ngIf="this.campaignService.checkFieldValidation('callbackDate', campaignService.dispositionForm)">
                            Please provide Date.
                        </div>
                    </div>
                </div>
                <div class="call-dropdown call-dropdown--multifield">
                    <div>
                        <label for="callbackHour" class="call-dropdown__label">
                            Hour
                        </label>
                        <span class="call-dropdown__opt-select">
                            <f-dropdown formControlName="callbackHour" placeholder="Select hour" [options]="callbackConfig.hours"
                                [ngStyle]="{ width: '100%' }" [style]="{ width: '100%' }">
                            </f-dropdown>
                        </span>
                        <div class="validation validation--error bottom-n15"
                            *ngIf="this.campaignService.checkFieldValidation('callbackHour', campaignService.dispositionForm)">
                            Please provide Hour.
                        </div>
                    </div>
                    <div>
                        <label for="callbackMins" class="call-dropdown__label">
                            Minutes
                        </label>
                        <span class="call-dropdown__opt-select">
                            <f-dropdown formControlName="callbackMins" placeholder="Select Mins" [options]="callbackConfig.minutes"
                                [ngStyle]="{ width: '100%' }" [style]="{ width: '100%' }">
                            </f-dropdown>
                        </span>
                        <div class="validation validation--error bottom-n15"
                            *ngIf="this.campaignService.checkFieldValidation('callbackMins', campaignService.dispositionForm)">
                            Please provide Mins.
                        </div>
                    </div>
                </div>
            </div>
            }
            <div *ngIf="campaignService.showReasonDropDown" class="single-input-field-wrapper">
                <div class="call-dropdown call-dropdown--addons ">
                    <label for="disposition" class="call-dropdown__label">
                        Select Reasons
                    </label>
                    <span class="call-dropdown__opt-select">
                        <f-multiSelect [filter]="true" placeholder="Select Reasons" [options]="campaignService.reasons"
                            formControlName="reasons" optionLabel="label" optionValue="value" [ngStyle]="{ width: '100%' }"
                            [style]="{ width: '100%' }">
                        </f-multiSelect>
                    </span>
                    <div class="validation validation--error bottom-n15"
                        *ngIf="this.campaignService.checkFieldValidation('reasons', campaignService.dispositionForm)">
                        Please provide reasons.
                    </div>
                </div>
            </div>
        
            <div *ngIf="campaignService.showOtherReasonTextBox" class="single-input-field-wrapper">
                <div class="note-action__boxes">
                    <textarea formControlName="otherReasons" rows="18" placeholder="Type"
                        class="dialer-textarea-reason"></textarea>
                    <div *ngIf="this.campaignService.checkFieldValidation('otherReasons', campaignService.dispositionForm)"
                        class="validation validation--error bottom-n15">
                        Please provide other reasons.
                    </div>
                </div>
            </div>
            <div class="call-dropdown" *ngIf="campaignService.showChatTfnTextbox">
                <label for="tfn" class="call-dropdown__label">
                    Chat TFN
                </label>
                <input formControlName="chatTfn" type="text" id="tfn" name="chatTfn" placeholder="Chat TFN"
                    class="call-dropdown__text-input" mask="(000) 000 0000" [showMaskTyped]="false" />
                <div *ngIf="this.campaignService.checkFieldValidation('chatTfn', campaignService.dispositionForm)"
                    class="validation validation--error bottom-n15">
                    Please provide chat tfn.
                </div>
            </div>
        
            <div class="submit-btn-wrapper">
                <!-- Submit Btn -->
                <button class="submit-btn submit-btn--red submit-btn--primary" (click)="disposeCall()">
                    <p class="submit-btn__name">Dispose Call</p>
                </button>
            </div>
        </form>
    </div>
</ng-container>
<div class="oncall-slider" [ngClass]="{ 'oncall-slider--collapsed': isContactOpen }"
    *ngIf="telephonyStateService.onCall && !telephonyStateService.isCallEnded">
    <div class="oncall-slider__content"><a class="slider-btn" data-slide="oncall-slider"
            (click)="toggleContactOpen()"><span>Contact</span></a>
        <div class="contacts-list-wrapper">
            <ul class="contacts-list contacts-list--secondary">
                <li>
                    <div class="search-module-container">
                        <div class="search-module" data-input="search">
                            <i class="fa-regular fa-magnifying-glass search-module__icon"></i>
                            <input type="text" placeholder="Search" class="search-module__input" maxlength="25"
                                [(ngModel)]="searchNumber">
                        </div>
                    </div>
                </li>
                <!-- <ng-scrollbar style="height: 400px"> -->
                <div class="dialpad-contact-container">
                    <li *ngFor="let number of numbers | filter:searchNumber :'Name'">
                        <!-- Info Card -->
                        <div class="info-cards info-cards--contact info-cards--contact-revised"
                            (click)="setTransferNumber(number.PhoneNumber);">
                            <div class="info-cards__content">
                                <!-- User Avatar -->
                                <div class="user-avatar user-avatar--contact user-avatar--contact-primary">
                                    <span class="user-avatar__img">
                                        {{ getName(number.Name) }}
                                    </span>
                                    <i class="user-avatar__status-icon user-avatar__status-icon--bordered bg-green bg-green"></i>
                                </div>
                                <div class="details">
                                    <div>
                                        <h4>{{ number.Name }}</h4>
                                        <h5>{{ number.PhoneNumber }}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </div>
                <!-- </ng-scrollbar> -->
            </ul>
        </div>
    </div>
</div>